export const categories = [
  {
    id: '911-baoliao',
    slug: '911-baoliao',
    name: '911爆料',
    description: '全网独家深度爆料，直击娱乐圈最隐秘的角落',
    icon: 'ri-spy-line',
    color: 'bg-accent-100 text-accent-900',
  },
  {
    id: '51-baoliao',
    slug: '51-baoliao',
    name: '51爆料',
    description: '实锤爆料与内幕揭秘，让真相不再沉默',
    icon: 'ri-flashlight-line',
    color: 'bg-secondary-100 text-secondary-900',
  },
  {
    id: '91-baoliao',
    slug: '91-baoliao',
    name: '91爆料',
    description: '起底娱乐圈深层黑幕，揭开光鲜背后的暗面',
    icon: 'ri-search-eye-line',
    color: 'bg-accent-100 text-accent-900',
  },
  {
    id: 'yule-bagua',
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '明星动态与娱乐圈最新八卦一网打尽',
    icon: 'ri-chat-smile-2-line',
    color: 'bg-secondary-100 text-secondary-900',
  },
  {
    id: 'wanghong-heiliao',
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '追踪网红圈最新翻车现场与塌房实录',
    icon: 'ri-alert-line',
    color: 'bg-accent-100 text-accent-900',
  },
  {
    id: 'meiri-baoliao',
    slug: 'meiri-baoliao',
    name: '每日爆料',
    description: '每日最新鲜热辣的吃瓜资讯定时送达',
    icon: 'ri-fire-line',
    color: 'bg-secondary-100 text-secondary-900',
  },
];